import { Box, Paper } from '@mui/material';
import styled from 'styled-components';

export default styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const Item = styled(Paper)`
  text-align: center;
  padding: 10px;
  line-height: 60px;
`;

export const MyBox = styled(Box)`
  margin-right: 20px;
`;
